import {sleep} from '@/utils/sleep.js'

export const YANDEX_METRIKA_IDS = {
  bodybase: 109924287,
  younesis: 97062773,
}

export function getYandexMetrikaId(pageTitle) {
  return YANDEX_METRIKA_IDS[pageTitle] ?? null
}

let currentMetrikaId = null
let isScriptLoading = false

function loadMetrikaScript() {
  if (window.ym || isScriptLoading) {
    return
  }

  isScriptLoading = true

  ;(function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () {
      (m[i].a = m[i].a || []).push(arguments)
    }
    m[i].l = 1 * new Date()
    for (var j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) {
        return
      }
    }
    k = e.createElement(t)
    a = e.getElementsByTagName(t)[0]
    k.async = 1
    k.src = r
    a.parentNode.insertBefore(k, a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')
}

export function initYandexMetrika(pageTitle) {
  const metrikaId = getYandexMetrikaId(pageTitle)

  if (!metrikaId || currentMetrikaId === metrikaId) {
    return
  }

  currentMetrikaId = metrikaId
  loadMetrikaScript()

  void async function () {
    while (!window.ym) {
      await sleep(100)
    }

    window.ym(metrikaId, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
    })
  }()
}

export function yandexMetrika(type, value, params) {
  void async function () {
    if (!currentMetrikaId) {
      return
    }

    while (!window.ym) {
      await sleep(1000)
    }

    window.ym(currentMetrikaId, type, value, params)
  }()
}
